import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BackgroundStateService {
  private _isBackground = false;

  setBackgroundState(state: boolean) {
    this._isBackground = state;
  }

  get isBackground(): boolean {
    return this._isBackground;
  }
}
